module.exports = __webpack_public_path__ + "static/media/manage-members.c5fc4fca.png";